import { Module, VuexModule, Mutation, Action } from "vuex-module-decorators";
import {
  NotificationCategory,
  toNotificatonCategory,
  toString,
} from "@/models/notifications/NotificationCategory";
import store from "../store";
import Vue from "vue";

/**
 * 🧩 Module which is responsible for managing notification preferences
 */
@Module
export default class NotificationPreferencesModule extends VuexModule {
  
  // 📦 Disabled types of notifications
  public disabledNotificationPreferences: NotificationCategory[] | null = null;

  /**
   * 👾 Mutation which sets the disabled notification types
   * @param disabledNotificationPreferences
   */
  @Mutation
  public setDisabledNotificationPreferences(
    newDisabledNotificationPreferences: NotificationCategory[]
  ) {
    this.disabledNotificationPreferences = newDisabledNotificationPreferences;
  }

  /**
   * 🚀 Fetches the current user's disabled notification preferences
   */
  @Action
  public fetchDisabledNotificationPreferences() {
    Vue.prototype.$api.get("/api/v1/notifpreferences").then((response: any) => {
      let localDisabledNotificationPreferences: NotificationCategory[] = [];

      (response.data.result as string[]).forEach((notificationType: string) => {
        localDisabledNotificationPreferences.push(
          toNotificatonCategory(notificationType)
        );
      });

      store.commit(
        "setDisabledNotificationPreferences",
        localDisabledNotificationPreferences
      );
    });
  }

  /**
   * 🚀 Updates the state of notification preference / preferences
   */
  @Action
  public updateNotificationPreferenceStatus(
    notificationPreferenceWrapper: any
  ) {
    if (notificationPreferenceWrapper.toBeEnabled) {
      // Enable notification preference
      Vue.prototype.$api
        .delete("/api/v1/notifpreferences", {
          category: toString(
            notificationPreferenceWrapper.notificationPreferenceCategory
          ),
        })
        .finally(() => {
          store.dispatch("fetchDisabledNotificationPreferences");
        });
    } else {
      // Disable notification preference
      Vue.prototype.$api
        .post("/api/v1/notifpreferences", {
          category: toString(
            notificationPreferenceWrapper.notificationPreferenceCategory
          ),
        })
        .finally(() => {
          store.dispatch("fetchDisabledNotificationPreferences");
        });
    }
  }
}
